import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Main } from "./ca/Main";
import { Header } from "./ca/header/Header";
import { CAMap } from "./ca/map/CAMap";
import { Login } from "./ca/pages/ELogin";
import { Over } from "./ca/pages/Over";
import { Plus } from "./ca/pages/Plus";
import { Privacy } from "./ca/pages/Privacy";
import { Terms } from "./ca/pages/Terms";
import {
  CaMapProvider,
  useAccount,
  useCaMapProvider,
  useConfig,
  useNavigateStart,
} from "./ca/state";
import { Workspace } from "./ca/workspace/Workspace";

const App = () => {
  const m = useCaMapProvider();
  const config = useConfig();
  const mapHidden = useLocation().pathname.startsWith("/workspace");
  const refresh = useAccount(({ refresh }) => refresh);
  const navigateStart = useNavigateStart();
  useEffect(() => {
    refresh();
  }, [refresh]);
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        navigateStart();
        return;
      }
      if (e.key.toLowerCase() === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        navigateStart();
        // Poll until the / route has mounted the <Search /> input, then focus.
        const deadline = performance.now() + 500;
        const tryFocus = () => {
          const el = document.querySelector<HTMLInputElement>('input[name="search"]');
          if (el) {
            el.focus();
            el.select();
            return;
          }
          if (performance.now() < deadline) requestAnimationFrame(tryFocus);
        };
        requestAnimationFrame(tryFocus);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [navigateStart]);
  return (
    <CaMapProvider value={m}>
      <div className="font-sans antialiased min-h-screen flex flex-col text-black">
        <title>{config.site.title}</title>
        <Header />
        {/* Eén persistente kaart-instance: verbergen, nooit unmounten — anders
            gaat de laag- en viewstate van /search en /location verloren. */}
        <CAMap
          className={`ca-cadamap pl-10 sm:pl-20 top-14 fixed w-full print:hidden ${mapHidden ? "hidden" : ""}`}
        />
        <Routes>
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/over" element={<Over />} />
          <Route path="/plus" element={<Plus />} />
          <Route path="/login" element={<Login />} />
          <Route path="/workspace/:projectId/research/:researchId" element={<Workspace />} />
          <Route path="/workspace/:projectId/:sessionId?" element={<Workspace />} />
          <Route path="*" element={<Main />} />
        </Routes>
      </div>
    </CaMapProvider>
  );
};
export default App;
